/* eslint-disable max-lines-per-function */

import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';

import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { faMoneyBill, faPenToSquare } from '@fortawesome/pro-regular-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Bezahlung() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();

  const data = form.state.values;

  return (
    <AccordionItem value="bezahlung">
      <AccordionTrigger className="flex gap-1">
        <FontAwesomeIcon icon={faMoneyBill} />
        <span className="text-neutrals-900 text-xl font-bold leading-7">
          {t('domain.mitarbeiter.create.steps.bezahlung.title')}
        </span>
      </AccordionTrigger>
      <AccordionContent>
        <div className="mt-4">
          <div className="flex items-center">
            <span className="text-neutrals-900 font-bold text-base leading-6">
              {t(
                'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.title',
              )}
            </span>
            <Button
              className="ml-auto"
              variant={'icon'}
              onClick={() => ctx.navigateToSubStep('bezahlung.bezahlungsart')}>
              <FontAwesomeIcon
                icon={faPenToSquare}
                className="text-primary-blue-600"
              />
            </Button>
          </div>

          <div className="py-2 grid grid-cols-2 gap-y-4 text-neutrals-800 leading-5 text-sm font-normal">
            <span>
              {t(
                'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.art.label',
              )}
            </span>
            <span className="text-neutrals-900 font-semibold">
              {t(
                'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.art.options.' +
                  data.bezahlung.bezahlungsart.art,
              )}
            </span>
            <span>
              {t(
                'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.verguetung.title',
              )}
            </span>
            <div className="flex flex-col">
              <span className="text-neutrals-900 font-semibold">
                {`${data.bezahlung.bezahlungsart.stundenlohn ?? '-'} €/Std.`}
              </span>

              <span className="text-neutrals-900 font-semibold">
                {`${data.bezahlung.bezahlungsart.monatsgehalt ?? '-'} €/Monat`}
              </span>
            </div>
          </div>
        </div>
      </AccordionContent>
    </AccordionItem>
  );
}
